<template>
<div>
    <header class="menu">
        <nav class="navbar fixed-top">
            <span class="side-menu-icon side-menu-bar">
              <img v-b-toggle.sidebar-left src="@/assets/menu.svg" alt="" class="img-fluid" />
              <div class="daily-txt" v-if="$store.state.isDailyMeeting=='yes'">
                <img src="@/assets/green-tick.svg" alt="">
                <span>Daily Standup</span>
              </div>
              <router-link to="/DailyStandUp" v-if="$store.state.isDailyMeeting=='no'">
                <div class="daily-txt">
                  <img src="@/assets/caution.svg" alt="">
                  <span>Daily Standup</span>
                </div>
              </router-link>
              <router-link to="/visiting-card">
                <div class="daily-txt">
                  <img src="@/assets/download-menu.svg" alt="">
                  <span>Visiting Card</span>
                </div>
              </router-link>
            </span>
            <a href="javascript:void(0);" v-if="this.$route.name === 'Home'" class="navbar-brand">Enquiries</a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'PrEnquries'" class="navbar-brand">Premium Enquiries</a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'Project'" class="navbar-brand">Projects</a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'Meeting'" class="navbar-brand">Meetings

            </a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'ManageBrokers'" class="navbar-brand">My CPs

            </a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'DailyStandUp'" class="navbar-brand">Daily Stand Up</a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'CpEngagement'" class="navbar-brand">My CP Engagement</a>
            <a href="javascript:void(0);" v-else-if="this.$route.name === 'MyCpMeeting'" class="navbar-brand">CP Meeting Requests</a>
            <a href="javascript:void(0);" v-else class="navbar-brand">Campaigns</a>
            <router-link :to="{ name: 'Help', params: {  name: 'Meeting' }}" v-if="this.$route.name === 'Meeting'" class="help-btn">Help<img src="@/assets/play-2.svg" class="ml-1" alt=""></router-link>
            <router-link :to="{ name: 'Help', params: {  name: 'Campaigns' }}" v-if="this.$route.name === 'Campaign'" class="help-btn">Help<img src="@/assets/play-2.svg" class="ml-1" alt=""></router-link>
        </nav>
    </header>

    <!-- Left Menu Sidebar -->
    <b-sidebar id="sidebar-left" :title="RoleName" bg-variant="white" backdrop shadow>
        <div class="px-3 py-2">
            <b-list-group class="list-group-flush">
                <b-list-group-item :to="'/'">Manage Enquiries</b-list-group-item>
                <b-list-group-item :to="'/Project'">Manage Project</b-list-group-item>
                <b-list-group-item :to="'/Meeting'">Manage Meeting</b-list-group-item>
                <b-list-group-item :to="'/Campaign'">Manage Campaigns</b-list-group-item>
                <b-list-group-item :to="'/Brokers'">Manage Brokers</b-list-group-item>
                <b-list-group-item :to="'/CpEngagement'">My CP Engagement</b-list-group-item>
                <b-list-group-item :to="'/MCMeetings'">My Client Meetings</b-list-group-item>
                <b-list-group-item :to="'/PrEnquries'">Premium Enquiries</b-list-group-item>
                <b-list-group-item :to="'/DailyStandUp'">My Daily Stand Up</b-list-group-item>
                <b-list-group-item :to="'/CpMeetingRequests'">My Cp Meeting Requests</b-list-group-item>

            </b-list-group>
        </div>
        <template #footer="">
            <span class="text-center d-block">{{userEmail}}</span>
            <div class="d-flex bg-white align-items-center px-3 py-2">
                <a href="javascript:void(0);" class="navbar-brand" @click="logout">Logout</a>
            </div>
        </template>
    </b-sidebar>
</div>
</template>

<script>
export default {
    data() {
      return {
        dailyStandupData: []
      }
    },
    created() {
        this.$store.dispatch('setActiveTitle', "Options")
        // console.log(this.$route)
    },
    methods: {
        logout() {
            swal({
                    title: "Are you sure?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                .then((willDelete) => {
                    if (willDelete) {
                        this.$axios.delete('logout')
                            .then(res => {
                                if (res.data.status == true) {
                                    localStorage.removeItem('radiate-crm-token');
                                    localStorage.removeItem('radiate-user-name');
                                    localStorage.removeItem('radiate-user-id');
                                    localStorage.removeItem('radiate-user-email');
                                    localStorage.removeItem('radiate-crm-role_id');
                                    localStorage.removeItem('radiate-crm-role_name');
                                    this.$router.replace('/login');
                                    return;
                                }
                            })
                            .catch(err => console.log(err));
                    }
                })
                
        },
        getDailyStandup() {
          this.$axios.get('daily_stand_ups/settings').then((res)=> {
            this.dailyStandupData = res.data;
            this.$store.state.isDailyMeeting = this.dailyStandupData.have_daily_stand_up_meet;
            this.dailyStandupData.stand_up_types.unshift({value: null, text: 'Select Standup Type'})
            this.$store.dispatch('setStandupType',this.dailyStandupData.stand_up_types)
          })
        }
    },
    computed: {
        RoleName() {
            return localStorage.getItem('radiate-crm-role_name')
        },
        userEmail() {
            return localStorage.getItem('radiate-user-email')
        }
    },
    mounted() {
      this.getDailyStandup();
    }
}
</script>

<style>

.navbar-brand{
  margin-left: auto !important;
  margin-right: 0 !important;
}
.menu nav.fixed-top {
    /* background: linear-gradient(
300.41deg
, #f58322 54.02%, #ffa151 114.97%); */
    box-shadow: none;
}
.side-menu-bar {
  display: flex !important;
  gap: 20px;
  align-items: center;
}
.daily-txt {
    color: #273444;
    font-family: Inter;
    font-size: 9px;
    font-weight: 500;
    letter-spacing: 0em;
    background-color: #ffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding:4px;
    gap: 5px;
    max-width: 68px;
}
</style>
